module.exports = __webpack_public_path__ + "img/google_maps_bg.495d26a4.jpg";